module.exports = __webpack_public_path__ + "static/media/  (85).acb73471.jpg";